import { environment } from "src/environments/environment";
import { CookiesConsentService } from '@ildes/services/cookies-consent.service';
import * as Sentry from "@sentry/angular-ivy";
import { enableProdMode } from '@angular/core';

export const initSentry = (cookiesConsent: CookiesConsentService) => {
    return () => {
        const acceptedCookies = cookiesConsent.cookiesAccepted();

        if (environment.production && acceptedCookies) {
            Sentry.init({
              ...environment.production && { release : environment.releaseVersion },
              environment: environment.production ? "production": "stage",
              dsn: environment.sentryApiKey,
              integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
              ],
              // Performance Monitoring
              tracesSampleRate: 1.0, //  Capture 100% of the transactions
              // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
              tracePropagationTargets: ["localhost", "ildes.co"],
              // Session Replay
              replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
              replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
            enableProdMode();
          }
    }
}
    